import ButtonComponent from './ButtonComponent';
import { saveAs } from "file-saver";
import logo from "../../pages/resources/logo-icon_1.png";
import exceljson from '../../config/excel.json';

const ButtonGenerateExcelAuditComponent = (props) => {

    const tbColumns = props.tbColumns
    const tbData = props.tbData
    const lbCustomer = props.lbCustomer
    const lbCategory = props.lbCategory
    const lbCities = props.lbCities
    const lbAttributes = props.lbAttributes
    const lbChannels = props.lbChannels
    const lbMeasurement = props.lbMeasurement
    const lbVariables = props.lbVariables
    const lbValores = props.lbValores
    const wbname = props.wbname

    const createDataExcel = async () => {

        const log = exceljson.xl["Customers"][lbCustomer.label]["Logo"];
        const customerlogo = require(`../../pages/resources/${log}`)
        const date = new Date();
        const glosario = exceljson.xl["Reports"]['Auditoria'][wbname]["Glosario"][lbValores[0].label][lbVariables.label];
        const Excel = require('exceljs');
        const fileName = `${wbname}.xlsx`;
        const wb = new Excel.Workbook();
        const detalle = wb.addWorksheet('DETALLE');
        const ws = wb.addWorksheet(`${wbname}`);
        const img = wb.addImage({ base64: logo, extension: 'png', })
        const imgDetail = wb.addImage({ base64: customerlogo, extension: 'png', })

        const fea = lbAttributes.map((obj) => { return obj.label; });
        const chan = lbChannels.map((obj) => { return obj.label; });
        const cit = lbCities.map((obj) => { return obj.label; });
        const mer = lbMeasurement.map((obj) => { return obj.label; });
        const names = ['date', 'customer', 'category', 'features', 'channels', 'cities', 'measurement']
        const titles = ['FECHA     :', 'CLIENTE :', 'CATEGORIA :', 'ATRIBUTOS :', 'CANALES    :', 'CIUDADES  :', 'MEDICIONES  :']

        const ob = []

        ob['date'] = date.toLocaleString();
        ob['customer'] = lbCustomer.label;
        ob['category'] = lbCategory.label;
        ob['features'] = fea.join();
        ob['channels'] = chan.join();
        ob['cities'] = cit.join();
        ob['measurement'] = mer.join();

        detalle.addImage(imgDetail, "E2:F5")
        ws.addImage(img, "B2:B4");
        ws.addImage(imgDetail, "D2:D4")
        detalle.addImage(img, "B2:C4");
        ws.mergeCells("A1:E5");
        detalle.mergeCells("A1:G5");
        const titleReport = ws.getCell("B7");
        const titleDetail = detalle.getCell("B9");
        titleReport.font = { name: 'Calibri', family: 4, size: 15, underline: true, bold: true };
        titleReport.value = "PARAMETROS DEL REPORTE";
        titleDetail.value = "GLOSARIO";

        const glosarioValue = detalle.getCell("B11");
        glosarioValue.value = `${glosario}`;

        for (let i = 0; i < names.length; i++) {
            var r = ws.addRow();
            for (let j = 0; j < 1; j++) {
                let cell = r.getCell(3);
                cell.value = ob[names[i]];
            }
            for (let j = 0; j < 1; j++) {
                let cell = r.getCell(2);
                cell.font = { bold: true }
                cell.value = titles[i];
            }
        }
        
        const subTitleReport = ws.getCell("B17");
        subTitleReport.font = { name: 'Calibri', family: 4, size: 15, underline: true, bold: true }
        subTitleReport.value = "RESULTADO DEL REPORTE";

        const subTitleDetail = detalle.getCell("D7");
        subTitleDetail.font = { name: 'Calibri', family: 4, size: 15, underline: true, bold: true }
        subTitleDetail.value = `${lbCustomer.label}|${lbCategory.label}`;

        for (var m = 2; m < 20; m++) {
            ws.getColumn(m).width = 20;
        }
        var headersRow = ws.addRow();
        var leftmarginheaders = 2;
        for (let j = 0; j < tbColumns.length; j++) {
            let cell = headersRow.getCell(leftmarginheaders);
            cell.fill = {
                type: 'pattern',
                pattern: 'none',
                bgColor: { argb: '62B682' }
            };
            cell.value = tbColumns[j]['name'];
            leftmarginheaders++
        }
        for (let i = 0; i < tbData.length; i++) {
            var leftmargindata = 2;
            var dataRow = ws.addRow();
            for (let j = 0; j < tbColumns.length; j++) {
                let cell = dataRow.getCell(leftmargindata);
                cell.value = tbData[i][tbColumns[j]['selector']];
                leftmargindata++
            }
        }

        wb.xlsx.writeBuffer().then(function (buffer) {
            saveAs(
                new Blob([buffer], { type: "application/octet-stream" }), fileName
            )
        })
    }
    return (
        <ButtonComponent onClick={createDataExcel} className=" px-4 py-1 bg-orange-400 rounded-md font-medium text-white ">
            {props.name}
        </ButtonComponent>
    )
}


export default ButtonGenerateExcelAuditComponent; 